/* eslint-disable jsx-a11y/alt-text */
import React from "react";
const CreditCard = ({ name, balance, pendingBalance }) => {
	return (
		<div className="ccard">
			<div className="shape" />
			<div className="top">
				<img
					className="light-image active"
					src="https://huro.cssninja.io/assets/img/icons/dashboards/banking/visa-text-white.svg"
					alt="Balance"
				/>
			</div>
			<div className="bottom">
				<span>{balance}</span>
				<span>Pending B/C: {pendingBalance}</span>
				<span>{name}</span>
			</div>
		</div>
	);
};

export default CreditCard;
